import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorhandlingService } from '../../Services/error-handling.service';

@Component({
  selector: 'app-kyc-popup',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './kyc-popup.component.html',
  styleUrls: ['./kyc-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KycPopupComponent {

  // 🔥 Dynamic content
  @Input() title: string = 'KYC Verification';
  @Input() message: string = '';
  @Input() buttonText: string = 'Got it';

  // 🔥 Optional routing
  @Input() redirectRoute: string | null = null;

  @Output() close = new EventEmitter<void>();

  constructor(private router: Router, private _errorHandleService: ErrorhandlingService) { }

  onAction() {
    if (this.redirectRoute) {
      // this.router.navigate([this.redirectRoute]);
      this._errorHandleService.showModalSubject.next(false);
      this.close.emit();


    }
    this.close.emit();

  }

  onClose() {
    this.close.emit();

  }

}
